module.exports = __webpack_public_path__ + "static/media/f8e80ba7587764ddfa27aa1e02c6ed54.f8e80ba7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/res/images/discordAssets/f8e80ba7587764ddfa27aa1e02c6ed54.svg
// module id = 1235
// module chunks = 21